<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap RiskAssessmentMeasuresReduction">
    <v-sheet class="contents-container">
      <!-- page Title -->
      <i-card-vertical headerTitle="위험성평가 감소대책 수립" device="web">
        <template v-slot:body>
          <v-sheet class="tab-layout" v-if="tabList">
            <v-sheet class="tab-left">
              <v-select
                :value="searchRiskAssessment"
                :menu-props="{ offsetY: true }"
                :items="riskAssessmentList"
                item-text="riskAssessmentNm"
                item-value="assessmentKey"
                class="search-select editor_bg"
                placeholder="위험성평가명"
                solo
                @change="handleSelectChange"
              ></v-select>
              <!-- 좌측 tab -->
              <v-card color="inner_card_bg" class="overflow-y-auto">
                <v-list class="pa-0 contents-menu">
                  <v-list-item-group color="primary">
                    <v-list-item
                      v-for="(item, index) in tabList"
                      :key="item.index"
                      @click="handleTabClick(index)"
                      :class="{ active: selectedKey === index }"
                    >
                      <v-list-item-content>
                        {{ item.processNm }}
                        <v-tooltip top color="primary" max-width="300px">
                          <template v-slot:activator="{ on }">
                            <span>
                              <span class="sub-text">감소대책 등록 필요 : {{ item.uncount }}</span>
                              <svg-icon icon-class="info" style="height: 1rem" v-on="on" />
                            </span>
                          </template>
                          <div class="tooltip-text">{{ '등록된 감소대책이 없고, 허용가능한 위험성수준 보다 높은 유해위험요인 수' }}</div>
                        </v-tooltip>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-sheet>
            <!-- 우측 테이블 영역 -->
            <!-- table -->
            <v-card class="overflow-y-auto" :class="breakpoint === 'md' || breakpoint === 'sm' || breakpoint === 'xs' ? 'mt-5' : ''">
              <div v-show="selectedKey === selectedKey">
                <reductionPanelTree
                  class="custom-panel"
                  ref="reductionPanelTree"
                  :tabList="tabList[selectedKey]"
                  :datasource="datasource"
                  :dataSetList="dataSetList"
                  :workDetailList="workDetailList"
                  :assessmentKey="titlePanel"
                  @titleClick="titleClick"
                />
              </div>
            </v-card>
          </v-sheet>
        </template>
        <template v-slot:drawer>
          <v-navigation-drawer v-model="procedureShow" width="75%" absolute right temporary class="feedback-area">
            <ProcedureComponent :type="'00002'" />
          </v-navigation-drawer>
        </template>
      </i-card-vertical>

      <v-sheet class="iCardRightWrap">
        <i-card-right :useBtnList="buttonUseList" @btnSearch="btnSearch(true)" @btnSave="btnSave" @btnPrint="btnPrint">
          <!-- <template v-slot:body>
          <v-layout>
            <v-row v-if="riskAssessmentList" no-gutters align="center" class="pa-0 pt-2" :key="test"></v-row>
          </v-layout>
          </template>-->
        </i-card-right>
        <i-card-right v-show="selectedKey === selectedKey">
          <template v-slot:customBtn>
            <i-icon-button color="btn_text" :text="'개설 이동'" :icon="'back'" @click="btnOpen" :appendDivider="true"></i-icon-button>
            <i-icon-button color="btn_text" :text="'이행 이동'" :icon="'forward'" @click="btnReduction"></i-icon-button>
          </template>
        </i-card-right>
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button color="btn_text" :text="'절차서'" :icon="'file'" @click="procedureShow = !procedureShow"></i-icon-button>
          </template>
        </i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>
<script>
// 공통 컴포넌트
import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import notify from 'devextreme/ui/notify'
import { AesDecrypt } from '@/utils/aes256'
import { getCurrentDate } from '@/utils/common.js'
import expansionPanelList from '@/components/esgCommon/expansionPanelList.vue'

import reductionPanelTree from './components/ReductionPanelTree'
//위험성평가명
import { getRiskAssessments } from '@/api/riskAssessment/riskAssessmentProcess.js'

//위험성평가 작업내용
import { getRiskAssessmentCreationList } from '@/api/riskAssessment/riskAssessmentCreation.js'
//위험성평가 세부내용
import {
  getRiskAssessmentMeasuresReductionList,
  saveRiskAssessmentMeasuresReduction,
  getRptRiskAssessmentMeasuresReduction,
  getRptRiskAssessmentMeasuresReductionList
} from '@/api/riskAssessment/riskAssessmentMeasuresReduction.js'

//공통코드
import { getCommonCode } from '@/api/common/commonApi'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'

export default {
  mixins: [baseview, BaseDataGrid],
  components: {
    reductionPanelTree,
    // 절차서 컴포넌트
    ProcedureComponent
  },
  data() {
    return {
      param: '',
      initCompId: '',
      buttonUseList: [
        'btnSearch', //조회
        'btnSave',
        'btnPrint'
      ],
      selectedKey: 0,
      tabList: [],
      riskAssessmentList: [],
      searchRiskAssessment: '',
      test: 0,
      routeData: '',
      datasource: [],
      expandedPanel: '',
      //타이틀
      userSubject: [],

      //캘린더
      menuStDate: false,
      menuEdDate: false,
      editingData: {},
      //파라미터
      panelData: '',
      titlePanel: 0,
      // 넘겨줄데이터
      dataSetList: [
        {
          riskFactorList: [],
          victimList: [],
          riskEstimation: '00001',
          riskEstimationList: [],
          riskEstimationSetting: [],
          infoBtnList: [],
          freqValueList: [],
          freqList: [],
          strengthList: [],
          deleteList: [],
          riskInit: {}
        }
      ],
      workDetailList: [],
      detailList: [],
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false // 절차서 보이기
    }
  },
  watch: {},
  created() {
    // 초기 페이지 진입 시 compId 세팅
    this.initCompId = this.getCompId()
    let param = {
      clntId: this.getClntId(),
      compId: this.initCompId
    }

    this.setComboBox(param)
  },
  activated() {
    // 페이지 이동시
    if (this.$route.params.data) {
      //초기화
      this.selectedKey = 0
      this.panel = 0
      // 페이지 이동시
      if (!this.$route.params.data.__created__) {
        // 페이지 이동 시, 다른 페이지에서 상세정보 조회 시
        let param = this.$route.params.data
        this.setComboBox(param)
      }
    }
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      // 데이터 공간 초기화
      this.tabList = []
      this.datasource = []
      this.param = ''
      this.initCompId = this.getCompId()
      let param = {
        clntId: this.getClntId(),
        compId: this.initCompId
      }
      this.setComboBox(param)
    }
  },
  beforeMount() {
    Promise.all([
      getCommonCode('RA004') /*위험분류 */,
      getCommonCode('RA005') /*위험성평가 사고발생시 피해예상자 */,
      getCommonCode('RA002') /*위험성 추정*/,
      getCommonCode('RA002_1'),
      getCommonCode('RA002_2'),
      getCommonCode('RA002_3')
    ])
      .then(response => {
        this.dataSetList[0].riskFactorList = response[0].list
        this.dataSetList[0].victimList = response[1].list
        this.dataSetList[0].riskEstimationList = response[2].list
        this.dataSetList[0].riskEstimation = response[2].list[0].minorCd
        this.dataSetList[0].riskEstimationList.forEach(el => {
          this.dataSetList[0].riskEstimationSetting[el.minorCd] = { minorNm: el.minorNm, minorCd: el.minorCd, data: [] }
        })
        this.dataSetList[0].riskEstimationValue = response[3].list
        response[3].list.forEach(el => {
          if (this.dataSetList[0].riskEstimationSetting[el.extra1]?.data) {
            this.dataSetList[0].riskEstimationSetting[el.extra1].data.push({ minorNm: el.minorNm, minorCd: el.minorCd, extra: el.extra2 })
          }
        })
        this.dataSetList[0].infoBtnList = response[4].list
        this.dataSetList[0].freqValueList = response[5].list
      })
      .finally(() => {
        if (Object.keys(this.dataSetList[0].riskEstimationSetting).length > 0) {
          this.dataSetList[0].freqList = this.dataSetList[0].riskEstimationSetting['00001'].data
            .filter(el => el.extra == 'frequency')
            .sort((a, b) => a.minorNm.localeCompare(b.minorNm))
          this.dataSetList[0].strengthList = this.dataSetList[0].riskEstimationSetting['00001'].data
            .filter(el => el.extra == 'strength')
            .sort((a, b) => a.minorNm.localeCompare(b.minorNm))
        }
      })
  },
  mounted() {},
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name
    }
  },
  methods: {
    setComboBox(param) {
      Promise.all([getRiskAssessments(param, false)]).then(response => {
        this.riskAssessmentList = response[0].list
        if (this.riskAssessmentList.length) {
          // // 페이지 이동 시
          if (this.$route.params.data && !this.$route.params.data.__created__) {
            this.param = this.$route.params.data
            // this.searchRiskAssessment = this.$route.params.searchRiskAssessment
            this.selectedKey = this.$route.params.selectedKey
            this.titlePanel = this.$route.params.panel
            this.searchRiskAssessment = param.clntId + '_' + param.compId + '_' + param.writeDt + '_' + param.docNo
            this.param = {
              clntId: param.clntId,
              compId: param.compId,
              writeDt: param.writeDt,
              docNo: param.docNo,
              constructId: param.constructId,
              processId: param.processId,
              __riskFactor__: true
            }
          } else {
            if (this.riskAssessmentList[0]) {
              this.searchRiskAssessment = this.riskAssessmentList[0].assessmentKey
              const [clntId, compId, writeDt, docNo] = this.searchRiskAssessment.split('_')
              this.param = {
                clntId: clntId,
                compId: compId,
                writeDt: writeDt,
                docNo: docNo,
                __riskFactor__: true
              }
            }
          }
          this.btnSearch(true)
        }
      })
    },
    async btnSearch(isNotify) {
      //삭제 공간 초기화
      this.dataSetList[0].deleteList = []
      if (this.param) {
        this.openLoading('searching')
        getRiskAssessmentCreationList(this.param, isNotify)
          .then(response => {
            if (response.success) {
              //tabList에 값을 할당하기전 미등록 감소대책 수 계산
              response.list.forEach(item => {
                item.uncount = item.works.reduce((acc, work) => {
                  return (
                    acc +
                    work.factor.reduce((acc, factorItem) => {
                      return acc + (factorItem.countYn == 'Y' && factorItem.reduction.length === 0 ? 1 : 0)
                    }, 0)
                  )
                }, 0)
              })

              this.tabList = response.list
            }
          })
          .finally(() => {
            this.endLoading()
            this.riskTypeSetting()
            this.detailSearch()
          })
      }
    },
    riskTypeSetting() {
      // 개설에서 빈도강도 or 수준3단계 default 값 가져오기
      this.dataSetList[0].riskInit = this.riskAssessmentList.find(el => el.assessmentKey === this.searchRiskAssessment)
      if (this.dataSetList[0].riskInit) {
        let riskType = this.dataSetList[0].riskEstimationValue.find(el => el.minorCd == this.dataSetList[0].riskInit.riskEstimationVal1)
        if (riskType) {
          this.dataSetList[0].riskEstimation = riskType.extra1
        }
      }
    },
    detailSearch() {
      const works = this.tabList[this.selectedKey]?.works
      if (!works || works.length === 0) return

      const currentWork = works[this.titlePanel]
      if (!currentWork) return

      this.processId = currentWork.processId
      this.constructId = currentWork.constructId

      let param = {
        clntId: this.param.clntId,
        compId: this.param.compId,
        writeDt: this.param.writeDt,
        docNo: this.param.docNo,
        processId: this.processId,
        constructId: this.constructId
      }
      getRiskAssessmentMeasuresReductionList(param)
        .then(response => {
          if (response.success) {
            this.detailList = response.list
          }
        })
        .finally(() => {
          const groupedData = {}

          this.detailList.forEach(item => {
            groupedData[item.workId] = (groupedData[item.workId] || 0) + 1
          })

          if (this.tabList[this.selectedKey].works || this.tabList[this.selectedKey].works.length > 0) {
            this.tabList[this.selectedKey].works.forEach(item => {
              // 작업내용 갯수 할당
              item.cnt = groupedData[item.workId] || 0
              let count = 0
              if (item.factor.length > 0) {
                //작업 내용이 있는
                item.factor.forEach(item => {
                  if (item.reduction.length > 0) {
                    item.reduction.forEach(el => {
                      //감소대책 갯수
                      count++
                    })
                  }
                })
              }
              //감소대책 갯수 할당
              item.count = count
            })

            this.datasource = this.tabList[this.selectedKey].works
          }
          this.riskValueSetting()
          if (!this.titlePanel) {
            //선택된 패널 없으면
            let panelIdx = 0
            this.titleClick(panelIdx)
          } else this.titleClick(this.titlePanel)
        })
    },
    riskValueSetting() {
      //위험성 수준 값이 없을 때 초기 값 개설에서 가져와서 보여주기
      this.detailList.forEach(item => {
        if (!item.riskEstimationVal1) {
          item.riskEstimationVal1 = this.dataSetList[0].riskInit.riskEstimationVal1
          item.riskEstimationNum1 = this.dataSetList[0].riskEstimationValue.find(el => el.minorCd == item.riskEstimationVal1).extra3

          if (this.dataSetList[0].riskEstimation == '00001') {
            //빈도강도법일때는 val2도 넣어주기
            item.riskEstimationVal2 = this.dataSetList[0].riskInit.riskEstimationVal2
            item.riskEstimationNum2 = this.dataSetList[0].riskEstimationValue.find(el => el.minorCd == item.riskEstimationVal2).extra3
          }
        }
      })
    },
    titleClick(index) {
      // this.personSearch(true)
      this.titlePanel = index
      const clickedWorkId = this.datasource[index].workId
      // 필요한 항목만 필터링하여 workDetailList에 할당
      this.workDetailList = []
      this.workDetailList = this.detailList.filter(item => item.workId === clickedWorkId)
    },

    btnSave(toRouter = null) {
      // 모든 요소가 조건을 충족하는지 확인하는 플래그
      let hasMissingFactors = false
      let failData = ''
      // 데이터 바인딩된 배열을 순회하며 확인
      console.log('##@@@  this.detailList', this.detailList)
      const filteredDetailList = this.detailList.filter(el => el.__created__ || el.__updated__)
      filteredDetailList.forEach((el, elIndex) => {
        if (el.reduction.length > 0) {
          el.reduction.forEach((item, itemIndex) => {
            item.riskEstimationVal1 = el.riskEstimationVal1
            item.riskEstimationVal2 = el.riskEstimationVal2
            item.riskEstimationAfterVal1 = el.riskEstimationAfterVal1
            item.riskEstimationAfterVal2 = el.riskEstimationAfterVal2
            item.riskFactorContent = el.riskFactorContent
            if (!item.planDt || !item.riskReduceMeasuresContent || item.person.length < 1) {
              hasMissingFactors = true
              failData = filteredDetailList[elIndex].riskFactorContent
            }
          })
        }
      })

      // 필수 입력 요소가 누락된 경우 경고 표시
      // if (hasMissingFactors) {
      //   this.vToastify(this.$t(`[유해위험요인: ${failData}]<br/>저장 입력 항목을 확인해주세요.`), 'info')
      //   return
      // }

      let saveData = []
      this.workDetailList.forEach((work, workIndex) => {
        // el.reduction.forEach(el => {
        if (work.reduction.length > 0) {
          const filteredReduction = work.reduction.filter(el => el.__created__ || el.__updated__)
          filteredReduction.forEach(reduce => {
            // reduce.riskEstimationAfterVal1 = work.riskEstimationAfterVal1
            // reduce.riskEstimationAfterVal2 = work.riskEstimationAfterVal2
            if (!reduce.planDt || !reduce.riskReduceMeasuresContent || reduce.person.length < 1) {
              hasMissingFactors = true
              failData = work.riskFactorContent
            }
            saveData.push(reduce)
          })
        }
        // saveData.push(el)
        // })
      })
      if (this.dataSetList[0].deleteList.length > 0) {
        saveData.push(...this.dataSetList[0].deleteList)
      }
      console.log('## saveData', saveData)
      if (saveData.length > 0) {
        saveData.forEach(el => {
          if (el.__updated__) {
            // 삭제된 경우는 제외
            if (el.riskEstimationVal2) {
              // 빈도강도법 일 때
              if (!el.riskEstimationAfterVal1 || !el.riskEstimationAfterVal2) {
                hasMissingFactors = true
                failData = el.riskFactorContent
              }
            } else {
              // 수준 3단계 법일 때
              if (!el.riskEstimationAfterVal1) {
                hasMissingFactors = true
                failData = el.riskFactorContent
              }
            }
          }
        })
      }
      if (hasMissingFactors) {
        this.vToastify(this.$t(`[유해위험요인: ${failData}]<br/>저장 입력 항목을 확인해주세요.`), 'info')
        return
      }
      if (toRouter === null) {
        this.vToastifyPrompt(this.$t('저장하시겠습니까?'), 'info', async current => {
          this.openLoading()
          saveRiskAssessmentMeasuresReduction(saveData, true)
            .then(res => {
              this.btnSearch(false)
            })
            .catch(() => {
              this.endLoading()
            })
            .finally(() => {
              this.endLoading()
              //삭제리스트 초기화
              this.dataSetList[0].deleteList = []
            })
        })
      } else {
        saveRiskAssessmentMeasuresReduction(saveData, true)
          .then(res => {
            this.btnSearch(false)
          })
          .catch(() => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
            //삭제리스트 초기화
            this.dataSetList[0].deleteList = []
            if (typeof toRouter === 'object') this.$router.push(toRouter)
          })
      }
    },

    handleTabClick(index) {
      /*
      if (!index) {
        this.selectedKey = 0
      }
      */
      let saveData = this.$refs.reductionPanelTree.workDetailList.filter(el => el.__created__ || el.__updated__)
      if (saveData.length === 0 && this.dataSetList[0].deleteList.length === 0) {
        this.selectedKey = index
        this.datasource = []
        this.workDetailList = []
        this.titlePanel = 0
        this.detailSearch()
      } else {
        this.vToastifySavePrompt(
          this.$t(`작성중인 데이터를 저장하시겠습니까?`),
          'info',
          async current => {
            this.btnSave(true)
            this.selectedKey = index
            this.datasource = []
            this.workDetailList = []
            this.titlePanel = 0
            this.detailSearch()
          },
          async current => {
            this.selectedKey = index
            this.datasource = []
            this.workDetailList = []
            this.titlePanel = 0
            this.detailSearch()
            this.dataSetList[0].deleteList = []
          }
        )
      }
    },

    handleSelectChange(value) {
      console.log('2 handleSelectChange', value)
      //데이터 초기화
      this.titlePanel = 0
      this.selectedKey = 0
      this.datasource = []
      this.searchRiskAssessment = value
      //재검색
      const [clntId, compId, writeDt, docNo] = this.searchRiskAssessment.split('_')
      this.param = {
        clntId: clntId,
        compId: compId,
        writeDt: writeDt,
        docNo: docNo,
        __riskFactor__: true
      }
      this.btnSearch(true)
    },
    btnOpen() {
      if (!this.searchRiskAssessment) {
        this.vSnackbar(this.$t('위험성평가를 선택해주세요.'), 'warn')
        return
      }
      let saveData = this.$refs.reductionPanelTree.workDetailList.filter(el => el.__created__ || el.__updated__)
      const toRouter = {
        name: 'RiskAssessmentManageDetail',
        params: {
          data: this.param
        }
      }
      if (saveData.length === 0 && this.dataSetList[0].deleteList.length === 0) {
        this.vToastifyPrompt(this.$t(`위험성평가 개설 페이지로 이동하시겠습니까?`), 'info', async current => {
          this.$router.push(toRouter)
        })
      } else {
        this.vToastifySavePrompt(
          this.$t('작성중인 데이터를 저장하고<br/> 위험성평가 개설 페이지로 이동하시겠습니까?'),
          'info',
          async current => {
            this.btnSave(toRouter)
          },
          async current => {
            this.$router.push(toRouter)
          }
        )
      }
    },
    btnReduction() {
      if (!this.workDetailList[0]) {
        this.vSnackbar(this.$t('선택된 공정이 없습니다.'), 'warning')
        return
      }

      let saveData = this.$refs.reductionPanelTree.workDetailList.filter(el => el.__created__ || el.__updated__)
      const toRouter = {
        name: 'RiskAssessmentImplementation',
        params: {
          data: {
            clntId: this.param.clntId,
            compId: this.param.compId,
            writeDt: this.param.writeDt,
            docNo: this.param.docNo,
            __created__: false
          },
          searchRiskAssessment: this.searchRiskAssessment,
          searchRiskProcess: this.workDetailList[0].constructId + '_' + this.workDetailList[0].processId,
          selectedKey: this.titlePanel
        }
      }
      if (saveData.length === 0 && this.dataSetList[0].deleteList.length === 0) {
        this.vToastifyPrompt(
          this.$t(`[${this.workDetailList[0].processNm}]<br/>위험성평가 이행 페이지로 이동하시겠습니까?`),
          'info',
          async current => {
            this.$router.push(toRouter)
          }
        )
      } else {
        this.vToastifySavePrompt(
          this.$t(`작성중인 데이터를 저장하고<br/> [${this.workDetailList[0].processNm}]<br/>위험성평가 이행 페이지로 이동하시겠습니까?`),
          'info',
          async current => {
            this.btnSave(toRouter)
          },
          async current => {
            this.$router.push(toRouter)
          }
        )
      }
    },
    btnPrint(type) {
      if (this.datasource.length < 1) {
        this.vSnackbar(this.$t('출력할 데이터가 없습니다.'), 'warn')
        return
      }
      console.log('왼쪽 탭Key', this.datasource[0].processId)
      this.openLoading()
      let params = {
        clntId: this.param.clntId,
        compId: this.param.compId,
        writeDt: this.param.writeDt,
        docNo: this.param.docNo,
        type: type
      }
      //PDF 출력 api
      console.log('params', params)
      getRptRiskAssessmentMeasuresReductionList(params)
        .then(res => {
          this.downloadReport(res)
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },

    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    downloadReport(res) {
      let link = document.createElement('a')
      // 객체를 만들어서 생성
      let objectUrl = window.URL.createObjectURL(res.data)
      link.href = objectUrl
      link.download = res.headers.filename
      link.click()
    }
  }
}
</script>

<style lang="scss" scoped></style>
